module.exports = __webpack_public_path__ + "static/media/SAITD.22175ab7.png";